import { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-theme-material.css";
import "ag-grid-community/styles/ag-grid.css";
import { useParams } from "react-router-dom";
 
export default function AgGridPaginatedTable({
  columns,
  perPage = 10,
  refreshCounter,
  getTableRows,
  onCellClicked = () => {},
  onSortChanged = () => {},
  onInputSearch,
}) {
  const params = useParams();
  const [gridApi, setGridApi] = useState(null);
 
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
 
  useEffect(() => {
    if (gridApi) {
      const dataSource = {
        getRows: async (params) => {
          gridApi.showLoadingOverlay();
          try {
            const { rows, total, error } = await getTableRows(
              perPage,
              params.endRow - perPage
            );
            gridApi.hideOverlay();
            if (error) {
              params.successCallback([], 0);
              gridApi.showNoRowsOverlay();
            } else {
              params.successCallback(rows, parseInt(total));
              if (rows.length === 0) gridApi.showNoRowsOverlay();
            }
          } catch (error) {
            gridApi.hideOverlay();
            params.successCallback([], 0);
            gridApi.showNoRowsOverlay();
            console.error("Error fetching rows:", error);
          }
        },
      };
      gridApi.setDatasource(dataSource);
    }
  }, [gridApi, refreshCounter, onInputSearch, params.slug]);
 
  return (
<div aria-live="polite" aria-busy={false} className="ag-theme-material" >
<AgGridReact
        columnDefs={columns}
        pagination={true}
        rowModelType="infinite"
        paginationPageSize={perPage}
        cacheBlockSize={perPage}
        onGridReady={onGridReady}
        onSortChanged={onSortChanged}
        domLayout="autoHeight"
        defaultColDef={{
          resizable: true,
          flex: 1,
        }}
        onCellClicked={onCellClicked}
        overlayNoRowsTemplate="<span class='ag-overlay-no-rows-center'>No records to show.</span>"
      />
</div>
  );
}